<template>
  <v-card :loading="isLoading">
    <v-card-text>
      <v-data-table
        :fixed-header="false"
        :height="undefined"
        v-bind="dataTableAttrs"
        :headers="headersShown"
        :items="list"
        :loading="isLoading"
        :options.sync="options"
        :server-items-length="total"
        :items-per-page.sync="itemsPerPage"
        v-model="selectedItems"
        @update:items-per-page="handleItemsPerPageUpdated"
      >
        <template v-slot:top>
          <rs-table-title-bar
            v-if="$refs.headSearch"
            title="Yönetim Şirketi Tanımları"
            icon="mdi-home-modern"
            :add-route="
              can('add-company')
                ? { name: 'definitions.companies.create' }
                : null
            "
            :hide-edit="!can('edit-company')"
            @clear-filters="$refs.headSearch.reset"
            @reload="loadList"
            @click:edit="handleEditClick"
            :edit-enabled="selectedItems.length === 1"
            :search.sync="search.query"
          />
        </template>

        <!-- eslint-disable-next-line -->
        <template v-slot:body.prepend="{ headers }">
          <rs-table-head-search
            :headers="headers"
            :search.sync="search"
            ref="headSearch"
          />
        </template>

        <!-- eslint-disable-next-line -->
        <template v-slot:body.append="{ headers }">
          <rs-table-foot-totals
            :headers="headers"
            :totals="footTotals"
            not-price
          />
        </template>

        <!-- eslint-disable-next-line -->
        <template v-slot:item.name="{ item }">
          <router-link
            :to="{
              name: 'definitions.companies.show',
              params: { id: item.id },
            }"
          >
            {{ item.name }}
          </router-link>
        </template>

        <!-- eslint-disable-next-line -->
        <template v-slot:item.edit="{ item }">
          <router-link
            class="btn btn-icon btn-sm btn-clean"
            :to="{
              name: 'definitions.companies.edit',
              params: { id: item.id },
            }"
          >
            <i class="menu-icon mdi mdi-pencil"></i>
          </router-link>
        </template>

        <!-- eslint-disable-next-line -->
        <template v-slot:item.owner_email="{ item }">
          <a :href="`mailto:${item.owner_email}`" v-if="item.owner_email">
            {{ item.owner_email }}
          </a>
        </template>

        <!-- eslint-disable-next-line -->
        <template v-slot:item.owner_phone="{ item }">
          <a :href="`tel:${item.owner_phone}`" v-if="item.owner_phone">
            {{ item.owner_phone }}
          </a>
        </template>

        <!-- eslint-disable-next-line -->
        <template v-slot:item.is_active="{ value }">
          <rs-table-cell-boolean :value="value" />
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { debounce } from "@/core/plugins/debounce";
import { filtersToURL, hasPermissions } from "@/view/mixins";

export default {
  mixins: [filtersToURL, hasPermissions],
  watch: {
    options: {
      handler() {
        this.setURLParams();
      },
      deep: true,
    },
    search: {
      handler: debounce(function () {
        this.options.page = 1;
        this.setURLParams();
      }),
      deep: true,
    },
  },
  data() {
    return {
      headers: [
        {
          text: "",
          value: "edit",
          searchable: false,
          sortable: false,
          width: "30px",
          align: "center",
          hide: () => !this.can("edit-company"),
        },
        {
          text: "Şirket Adı",
          value: "name",
          searchable: "text",
        },
        {
          text: "TYA Sayısı",
          value: "cluster_count",
          searchable: "number",
          sortable: true,
          align: "end",
        },
        {
          text: "BB Sayısı",
          value: "house_count",
          searchable: "number",
          sortable: true,
          align: "end",
        },
        {
          text: "Çalışan Sayısı",
          value: "company_user_count",
          searchable: "number",
          sortable: true,
          align: "end",
        },
        {
          text: "Şirket Yetkilisi",
          value: "owner_name",
          searchable: "text",
          sortable: true,
        },
        {
          text: "Şehir",
          value: "city_name",
          searchable: "location",
          locationTypeId: 2,
          sortable: true,
        },
        {
          text: "İlçe",
          value: "district_name",
          searchable: "location",
          locationTypeId: 3,
          parentId: () => this.search.city_name,
          sortable: true,
        },
        {
          text: "Yetkili Telefon",
          value: "owner_phone",
          searchable: "text",
        },
        {
          text: "Yetkili E-Posta",
          value: "owner_email",
          searchable: "text",
        },
        {
          text: this.$t("labels.status"),
          value: "is_active",
          searchable: "isActive",
          align: "center",
        },
      ],
      footTotals: [],
    };
  },
  methods: {
    loadList() {
      if (this.isLoading) {
        return;
      }

      this.isLoading = true;
      this.list = [];

      const params = Object.assign(
        this.buildSearchParams(this.search, this.options)
      );

      params.company_type_id = 1;

      this.$api
        .query("companies", { params })
        .then((response) => {
          if (response.data && response.data.data) {
            this.list = response.data.data;
          }

          if (response.data && response.data.meta) {
            this.total = response.data.meta.total;
            this.options.page = response.data.meta.current_page;
            this.itemsPerPage = response.data.meta.per_page;
            this.options.itemsPerPage = this.itemsPerPage;
            this.footTotals = response.data.meta.totals;
          }
        })
        .catch((error) => {
          this.handleError(error);
        })
        .finally(() => (this.isLoading = false));
    },
    handleEditClick() {
      if (this.selectedItems.length) {
        this.$router.push({
          name: "definitions.companies.edit",
          params: {
            id: this.selectedItems[0].id,
          },
        });
      }
    },
  },
};
</script>
